/**
 * Classifies a failed `rescheduleB2cOrder` for the confirm screen (PLA-881).
 * Tiers follow ADR-0036: slot-taken / expected -> warn, transient -> warn while
 * the customer can retry, anything else is a defect worth capturing.
 */

export type RescheduleErrorKind = "slot-taken" | "transient" | "expected" | "unexpected"

const bare = (code: string): string => code.replace(/^functions\//, "")

const SLOT_TAKEN = new Set(["failed-precondition", "already-exists"])
const TRANSIENT = new Set([
  "unavailable",
  "deadline-exceeded",
  "internal",
  "aborted",
  "cancelled",
  "resource-exhausted",
])
const EXPECTED = new Set(["invalid-argument", "not-found", "unauthenticated", "permission-denied"])
const TRANSIENT_MESSAGE = /NETWORK_ERROR|CONNECTION_ERROR|TIMEOUT_ERROR|Network Error/i

export function classifyRescheduleError(
  code: string | null | undefined,
  message?: string | null,
): RescheduleErrorKind {
  if (code) {
    const c = bare(code)
    if (SLOT_TAKEN.has(c)) return "slot-taken"
    if (TRANSIENT.has(c)) return "transient"
    if (EXPECTED.has(c)) return "expected"
  }
  return message && TRANSIENT_MESSAGE.test(message) ? "transient" : "unexpected"
}

export const TRANSIENT_RETRY_MESSAGE =
  "Das hat gerade nicht geklappt. Bitte versuchen Sie es erneut."

export const slotTakenMessage = (time: string): string =>
  `${time} Uhr ist gerade vergeben worden. Bitte wählen Sie eine andere Uhrzeit, die übrigen Termine sind weiterhin frei.`
